export default __webpack_public_path__ + "static/media/close_icon_light.4c8c7aaf.svg";